import React from 'react';
import { BasicButton, IBasicButtonProps } from 'src/design/atoms/BasicButton';

export type ISecondaryButtonProps = IBasicButtonProps;

const DefaultProps: Partial<ISecondaryButtonProps> = {
  variant: 'light',
  color: 'dark',
};

/** @registry Light black/gray button for secondary actions (e.g. Cancel) next to a primary BasicButton. */
export const SecondaryButton = React.forwardRef<
  HTMLButtonElement,
  ISecondaryButtonProps
>(({ children, ...props }, ref) => {
  return (
    <BasicButton {...DefaultProps} {...props} ref={ref}>
      {children}
    </BasicButton>
  );
});
SecondaryButton.displayName = 'SecondaryButton';
